import { StoreOrder } from '../../models';

export const ORDER_STATUS = {
  Pending: 1,
  Completed: 2,
  Canceled: 3,
  AwaitingPayment: 6,
} as const;

interface OrderStatusView {
  dotClass: string;
  nextStep: string | null;
}

const STATUS_VIEWS: Record<number, OrderStatusView> = {
  [ORDER_STATUS.Pending]: {
    dotClass: 'bg-damasco',
    nextStep: 'Recebemos seu pedido e estamos separando as peças.',
  },
  [ORDER_STATUS.Completed]: {
    dotClass: 'bg-olivine',
    nextStep: null,
  },
  [ORDER_STATUS.Canceled]: {
    dotClass: 'bg-danger',
    nextStep: null,
  },
  [ORDER_STATUS.AwaitingPayment]: {
    dotClass: 'bg-chocolate',
    nextStep: 'Conclua o pagamento para garantir as peças.',
  },
};

const FALLBACK_VIEW: OrderStatusView = { dotClass: 'bg-text-light', nextStep: null };

export function getOrderStatusView(order: StoreOrder, hasPendingReviews: boolean): OrderStatusView {
  const view = STATUS_VIEWS[order.status] ?? FALLBACK_VIEW;
  if (order.status === ORDER_STATUS.Completed && hasPendingReviews) {
    return { ...view, nextStep: 'Conte o que achou das peças e ajude outras famílias a escolher.' };
  }
  return view;
}

export function isOrderInProgress(order: StoreOrder) {
  return order.status === ORDER_STATUS.Pending || order.status === ORDER_STATUS.AwaitingPayment;
}
